import { CollectionPricingHero } from "./collection-pricing-hero.tsx";

export const TeamworkCollectionPricingHero = () => {
    return (
        <CollectionPricingHero
            collectionImage={{
                src: "https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg",
                alt: "Teamwork Collection"
            }}
            products={[
                {
                    name: "Jira",
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg",
                        alt: "Jira"
                    }
                },
                {
                    name: "Confluence",
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg",
                        alt: "Confluence"
                    }
                },
                {
                    name: "Loom",
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg",
                        alt: "Loom"
                    }
                },
                {
                    name: "Rovo",
                    image: {
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg",
                        alt: "Rovo"
                    }
                }
            ]}
        />
    );
};
